import { ChangeEvent, useEffect, useState } from "react";
import { SavingInformationComponent } from "./savingsInformationComponents";
import { getConfigSavings } from "../../../core/service/api_saving";

interface ManualInputProps {
  onChangeValue: (value: number) => void;
}

export const ManualInputComponent = ({ onChangeValue }: ManualInputProps) => {
  const [amount, setAmount] = useState<number>(0);

  useEffect(() => {
    onChangeValue(amount);
  }, [amount]);

  return (
    <>
      <div className="w-full flex flex-col gap-4">
        <div className="flex items-center justify-center w-full">
          {/* Container utama dengan justify-center */}
          <div className="flex items-baseline justify-center border-b border-gray-300 pb-1 w-full mt-5">
            {/* Currency Prefix */}
            <span className="text-3xl font-bold text-gray-800 select-none mr-1">
              Rp.
            </span>

            {/* Input Field */}
            <input
              type="number"
              value={amount === 0 ? "" : amount}
              onInput={(e: ChangeEvent<HTMLInputElement>) =>
                setAmount(Number(e.target.value))
              }
              className="text-4xl font-light  bg-transparent focus:outline-none text-center w-40 tracking-tight"
              placeholder="0"
            />
          </div>
        </div>
      </div>

      <style>{`
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
      `}</style>
    </>
  );
};
